import { Loader2, RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

import { useAppVersion } from './useAppVersion';

const VersionBanner = () => {
    const { hasUpdate, reload, isReloading } = useAppVersion();

    // The live region stays mounted even with no update — live regions
    // inserted together with their content are often not announced.
    if (!hasUpdate) {
        return <div role="status" aria-live="polite" className="sr-only" />;
    }

    return (
        <div
            role="status"
            aria-live="polite"
            data-testid="version-banner"
            // Bottom-center: toasts own top-center. Cleared above the mobile
            // safe-area inset.
            className={cn(
                'fixed left-1/2 z-50 flex -translate-x-1/2 items-center gap-3',
                'rounded-xl border border-border bg-card/95 px-4 py-2.5',
                'text-sm backdrop-blur-sm',
                'shadow-[0_8px_32px_rgba(0,0,0,0.5)]',
                'max-w-[calc(100vw-1.5rem)]',
            )}
            style={{ bottom: 'calc(env(safe-area-inset-bottom) + 1rem)' }}
        >
            <RefreshCw
                size={16}
                className="shrink-0 text-muted-foreground"
                aria-hidden="true"
            />
            <span className="truncate text-foreground">
                A new version of SnappyTrade is available
            </span>
            <Button
                type="button"
                size="sm"
                data-testid="version-banner-reload"
                onClick={reload}
                disabled={isReloading}
                aria-busy={isReloading}
                className="shrink-0 disabled:cursor-progress"
            >
                {isReloading && (
                    <Loader2
                        size={14}
                        className="animate-spin"
                        aria-hidden="true"
                    />
                )}
                {isReloading ? 'Updating…' : 'Reload'}
            </Button>
        </div>
    );
};

VersionBanner.displayName = 'VersionBanner';

export { VersionBanner };
